export function getLeavingPanelIndicesForSlide(
    previousActiveIndex,
    nextActiveIndex,
    { mobile = false, numPanels = 3, leftSidebarOpen = false } = {},
) {
    if (!Number.isInteger(previousActiveIndex) || !Number.isInteger(nextActiveIndex)) return []
    if (previousActiveIndex === nextActiveIndex) return []

    if (mobile || numPanels === 1) return [previousActiveIndex]

    if (nextActiveIndex > previousActiveIndex) {
        return leftSidebarOpen
            ? [previousActiveIndex, previousActiveIndex + 1]
            : [previousActiveIndex]
    }

    return [previousActiveIndex + 2]
}

export function getLeavingPanelIndexForSlide(previousActiveIndex, nextActiveIndex, options = {}) {
    return getLeavingPanelIndicesForSlide(previousActiveIndex, nextActiveIndex, options)[0] ?? null
}
